import { createActions } from 'redux-actions';

export const {
  trustpilot: {
    getLoggedStatus, setLoggedStatus,
  },
}: any = createActions({
  TRUSTPILOT: {
    GET_LOGGED_STATUS: () => ({
      inProgress: true,
    }),
    SET_LOGGED_STATUS: (isLogged) => ({
      isLogged,
      inProgress: false,
    }),
  },
});
